import React from "react";
import { COLOR_PRIMARY } from "../../constants/colors";

const IconBook1 = ({ color = {COLOR_PRIMARY} }) => {
  return (
    <svg
      id="UI_icon_book_light"
      data-name="UI icon/book/light"
      xmlns="http://www.w3.org/2000/svg"
      width="38.333"
      height="32.48"
      viewBox="0 0 38.333 32.48"
    >
      <path
        id="Union"
        d="M19.166,32.48a1.911,1.911,0,0,1-.605-.1l-3.374-1.125a11.463,11.463,0,0,0-3.636-.59h-5.8A5.757,5.757,0,0,1,0,24.916V5.749A5.756,5.756,0,0,1,5.749,0h7.668a7.669,7.669,0,0,1,5.749,2.6A7.671,7.671,0,0,1,24.916,0h7.668a5.756,5.756,0,0,1,5.749,5.749V24.916a5.757,5.757,0,0,1-5.749,5.751h-5.8a11.463,11.463,0,0,0-3.636.59l-3.374,1.125A1.911,1.911,0,0,1,19.166,32.48ZM24.916,3.833a3.837,3.837,0,0,0-3.833,3.833V27.9l.85-.283a15.322,15.322,0,0,1,4.849-.787h5.8A1.92,1.92,0,0,0,34.5,24.916V5.749a1.919,1.919,0,0,0-1.916-1.916Zm-19.166,0A1.919,1.919,0,0,0,3.833,5.749V24.916a1.92,1.92,0,0,0,1.916,1.918h5.8a15.322,15.322,0,0,1,4.849.787l.85.283V7.666a3.837,3.837,0,0,0-3.833-3.833Z"
        fill={color}
      />
    </svg>
  );
};

export default IconBook1;
